var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-inner"},[_c('app-section',{attrs:{"title":_vm.page.title,"desc":_vm.page.desc,"bgIntro":"lighter"}}),_c('push',{attrs:{"page":_vm.page.page_push}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }